export const calculateHaversineDistance = (lat1, lon1, lat2, lon2) => {
    const R = 6371; // Earth's radius in km
    const dLat = (lat2 - lat1) * (Math.PI / 180);
    const dLon = (lon2 - lon1) * (Math.PI / 180);
    const a =
        Math.sin(dLat / 2) * Math.sin(dLat / 2) +
        Math.cos(lat1 * (Math.PI / 180)) *
        Math.cos(lat2 * (Math.PI / 180)) *
        Math.sin(dLon / 2) *
        Math.sin(dLon / 2);
    const c = 2 * Math.atan2(Math.sqrt(a), Math.sqrt(1 - a));
    return (R * c).toFixed(2);
};


export const getDistanceWithFallback = (trackerLink, providedDistance) => {
    if (providedDistance && parseFloat(providedDistance) > 0) {
        return typeof providedDistance === 'number' ? providedDistance.toFixed(2) : providedDistance;
    }

    if (trackerLink) {
        try {
            const decodedLink = decodeURIComponent(trackerLink);
            const urlParams = new URLSearchParams(decodedLink.split("?")[1]);
            const origin = urlParams.get("origin")?.split(",").map(Number);
            const destination = urlParams.get("destination")?.split(",").map(Number);

            if (origin?.length === 2 && destination?.length === 2) {
                return calculateHaversineDistance(origin[0], origin[1], destination[0], destination[1]);
            }
        } catch (error) {
            console.error("Error calculating fallback distance:", error);
        }
    }
    return providedDistance || "0.00";
};
